export const CHECKMARK = { label: 'Checkmarks', value: 'checkmark' };
export const CIRCLE = { label: 'Circles', value: 'circle' };
export const HEART = { label: 'Hearts', value: 'heart' };
export const SMILE = { label: 'Smiley faces', value: 'smile' };
export const STAR = { label: 'Stars', value: 'star' };
export const THUMB_UP = { label: 'Thumbs-up', value: 'thumbup' };
